import { Button } from 'primereact/button'
import React from 'react'
const AppErrorBoundry = () => {
    return (
        <div className="grid full-screen lg-screen pt-4">
            <div className="col-6 banner">
                <div className="image"></div>
                <h1>All-in-one Workspace</h1>
                <p>
                    <em>Timesheet, Leaves, Payroll and get organized.</em>
                    <em><strong>ESS</strong> is all you need - in one tool</em>
                    <small>@2023, Espire Infolab Pvt. Ltd. All Rights Reserved</small>

                </p>
            </div>
            <div className='col-6 banner pt-3'>
                <span style={{ paddingTop: '10%' }}>
                    <img src='/assets/images/crash.png' />
                </span>
                <h1>Looks like there was a problem</h1>
                <p>Please either refresh the page or return to the dashboard to try again</p>
                <p>If the issue persists, please raise a support request at support@espire.com.</p>
                <Button className='p-button-secondary mt-3' label='Dashboard' onClick={() => window.location.href = '/dashboard'} />
            </div>
        </div>
    )
}

export default AppErrorBoundry